window.theme = window.theme || {};

Shopify.formatMoney = function (cents, format) {
  var value = "",
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || this.money_format;

  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// Helper functions
function replaceUrlParam(url, paramName, paramValue) {
  var pattern = new RegExp("(" + paramName + "=).*?(&|$)"),
    newUrl = url;
  if (url.search(pattern) >= 0) {
    newUrl = url.replace(pattern, "$1" + paramValue + "$2");
  } else {
    newUrl = newUrl + (newUrl.indexOf("?") > 0 ? "&" : "?") + paramName + "=" + paramValue;
  }
  return newUrl;
}

/* ================ TIMBER ================ */
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $("html"),
    $body: $("body"),

    // Navigation

    // Collection Pages
    $changeView: $(".change-view"),
    $collectionFilters: $("#collectionFilters"),
    $toggleFilterBtn: $("#toggleFilters"),

    // Customer Pages
    $recoverPasswordLink: $("#RecoverPassword"),
    $hideRecoverPasswordLink: $("#HideRecoverPasswordLink"),
    $recoverPasswordForm: $("#RecoverPasswordForm"),
    $customerLoginForm: $("#CustomerLoginForm"),
    $passwordResetSuccess: $("#ResetSuccess"),
  };
};

timber.init = function () {
  timber.cacheSelectors();
  timber.responsiveVideos();
  timber.responsiveTables();
  timber.toggleFilters();
  timber.collectionViews();
  timber.loginForms();
};

timber.getHash = function () {
  return window.location.hash;
};

timber.updateHash = function (hash) {
  window.location.hash = "#" + hash;
  $("#" + hash)
    .attr("tabindex", -1)
    .focus();
};

timber.switchZoom = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr("data-zoom-image", src);
};

timber.responsiveVideos = function () {
  $('iframe[src*="youtube.com/embed"]').wrap('<div class="video-wrapper"></div>');
  $('iframe[src*="player.vimeo"]').wrap('<div class="video-wrapper"></div>');
};

timber.responsiveTables = function () {
  $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
};

timber.toggleFilters = function () {
  if (timber.cache.$collectionFilters.length) {
    timber.cache.$toggleFilterBtn.on("click", function () {
      timber.cache.$toggleFilterBtn.toggleClass("is-active");
      timber.cache.$collectionFilters.slideToggle(200);
    });
  }
  var mediaQuerySmall = "screen and (max-width: 768px)";
  enquire.register(mediaQuerySmall, {
    match: function () {
      timber.cache.$collectionFilters.hide();
    },
    unmatch: function () {
      timber.cache.$collectionFilters.show();
    },
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on("click", function () {
      var view = $(this).data("view"),
        url = document.URL,
        hasParams = url.indexOf("?") > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, "view", view);
      } else {
        window.location = url + "?view=" + view;
      }
    });
  }
};

timber.loginForms = function () {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on("click", function (evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on("click", function (evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == "#recover") {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function () {
  timber.cache.$passwordResetSuccess.show();
};

// Initialize Timber's JS on docready
$(timber.init);

/*============================================================================
    Pipeline Functions  )`-....._,.-'``'-.,_,.='``'-.,
==============================================================================*/

window.pipeline = window.pipeline || {};

pipeline.init = function () {
  pipeline.equalHeight();
  pipeline.matchHeight();
  pipeline.smoothScroll();
  pipeline.contentOverflow();
  pipeline.moveTags();
  pipeline.heightOverride();
};

pipeline.equalHeight = function () {
  var $columns = $(".equalHeightColumn");
  $columns.height("initial");
  var height = 0;
  $columns.each(function () {
    if ($(this).height() > height) {
      height = $(this).height();
    }
  });
  $columns.height(height);
};

$(window).resize(function () {
  var width = $(document).width();
  if (width > 1280) {
    $("body").removeClass("body--mobile-active");
  }
});

pipeline.smoothScroll = function () {
  $('a[href*="#"]:not([href="#"])').click(function (event) {
    if (
      location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") ||
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        event.preventDefault();
        $("html,body").animate(
          {
            scrollTop: target.offset().top,
          },
          1000,
        );
      }
    }
  });
};

pipeline.contentOverflow = function () {
  $(".preventOverflow").css("min-height", function () {
    var contentHeight = $(this).find(".preventOverflowContent").height();
    return contentHeight + 30;
  });
};

pipeline.heightOverride = function () {
  if (
    /Android|iPhone|iPad|iPod|BlackBerry/i.test(
      navigator.userAgent || navigator.vendor || window.opera,
    )
  ) {
    $(
      ".use_screen_full, .use_screen_three_quarters, .use_screen_two_thirds, .use_screen_one_half, .use_screen_one_third, .use_screen_one_fifth",
    ).css(
      "height",
      function () {
        return $(this).css("height");
      },
      "important",
    );
    $(
      ".use_screen_full .slideshow__slide, .use_screen_three_quarters .slideshow__slide, .use_screen_two_thirds .slideshow__slide, .use_screen_one_half .slideshow__slide, .use_screen_one_third .slideshow__slide",
    ).css(
      "height",
      function () {
        return $(this).css("height");
      },
      "important",
    );

    $(
      ".use_screen_full .double__block, .use_screen_three_quarters .double__block, .use_screen_two_thirds .double__block, .use_screen_one_half .double__block, .use_screen_one_third .double__block, .use_screen_one_fifth .double__block",
    ).css(
      "height",
      function () {
        return $(this).css("height");
      },
      "important",
    );
  }
};

pipeline.matchHeight = function () {
  $(".equalOverflowHeight").css("min-height", function () {
    var blockHeights = $(".preventOverflowContent")
      .map(function () {
        return $(this).height();
      })
      .get();
    var tallest = Math.max.apply(null, blockHeights);
    return tallest + 30;
  });
};

pipeline.moveTags = function () {
  $(".homepage--white:not(.homepage-image)").parent().addClass("adjust--white");
  $(".homepage--light:not(.homepage-image)").parent().addClass("adjust--light");
  $(".homepage--splash:not(.homepage-image)").parent().addClass("adjust--splash");
  $(".homepage--dark:not(.homepage-image)").parent().addClass("adjust--dark");
};

$(window)
  .resize(function () {
    pipeline.contentOverflow();
    pipeline.equalHeight();
    pipeline.matchHeight();
    pipeline.heightOverride();
  })
  .resize();

$(window).load(function () {
  $(window).resize();
});

$(pipeline.init);

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");
    constructor = constructor || this.constructors[type];

    return _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    this.instances.push(this._createInstance(container));
    pipeline.moveTags();
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this.instances.push(this._createInstance(container, constructor));
      }.bind(this),
    );
  },
});

theme.Product = (function () {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");

    this.settings = {
      sectionId: sectionId,
      enableHistoryState: true,
      namespace: ".product-single",
    };

    this.selectors = {
      productSection: "#ProductSection-" + sectionId,
      productImage: ".ProductImg-" + sectionId,
      productThumbs: "#ProductThumbs-" + sectionId,
      originalSelectorId: "#ProductSelect-" + sectionId,
      singleOptionSelector: ".single-option-selector-" + sectionId,
      addToCart: "#AddToCart-" + sectionId,
      productPrice: "#ProductPrice-" + sectionId,
      buttonPrice: "#ButtonPrice-" + sectionId,
      comparePrice: "#ComparePrice-" + sectionId,
      comparePriceWrapper: "#ComparePriceWrapper" + sectionId,
      addToCartText: "#AddToCartText-" + sectionId,
      productPhoto: "#ProductPhoto-" + sectionId,
      quantityElements: "#Quantity-" + sectionId,
      quantityInput: "#Quantity-" + sectionId + " .QuantityInput",
      variantDropdown: "#ProductSelect-" + sectionId,
      popupButton: "#toggleProductModal-" + sectionId,
      image: ".ProductImg-" + sectionId,
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$("#ProductJson-" + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById("ProductJson-" + sectionId).innerHTML,
    );
    this.zoomEnable = $container.data("image-zoom-enable");

    this.stringOverrides();
    this.initProductVariant();
    this.pageModal();
    this.initSlider();
    this.productVideo();

    if (this.zoomEnable) {
      this.productImageZoom();
    }
  }
  Product.prototype = _.assignIn({}, Product.prototype, {
    initProductVariant: function () {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject,
      };
      this.status = $("#product-status").val();
      this.next_date_available = $("#product-next-available").val();
      this.qty_available = $("#product-qty-available").val();
      this.variants = new theme.Variants(options);
      this.$container.on(
        "variantChange" + this.settings.namespace,
        this.updateAllVariants.bind(this),
      );
      this.updateAllVariants({ variant: this.variants.currentVariant });
    },
    updateAllVariants: function (evt) {
      var variant = evt.variant;
      var moneyFormat = theme.moneyFormat,
        addToCartText = theme.strings.addToCart,
        membershipProduct = document.getElementById("MembershipJson-" + this.settings.sectionId);

      if (variant) {
        // Update variant image, if one is set
        if (variant.featured_image) {
          var newImg = $(
            this.selectors.productImage + '[data-image-id="' + variant.featured_image.id + '"]',
          );
          var newPosition = newImg.parent().attr("data-slick-index");

          // Slider not loaded
          if (newPosition === undefined) {
          } else {
            $(this.selectors.productPhoto).slick("slickGoTo", newPosition);
          }
        }
        // Select a valid variant if available
        if (variant.available) {
          //debugger
          // Available, enable the submit button, change text, show quantity elements
          //$(this.selectors.addToCart).removeClass('disabled').prop('disabled', false);

          if (this.qty_available <= 0 && this.next_date_available.indexOf("2079") < 0) {
            if ($("#customer_discount").length > 0) {
              $(this.selectors.addToCart).removeClass("disabled").prop("disabled", false);
              $(this.selectors.addToCartText).html("Pre-Order");
              date = new Date(this.next_date_available);

              //debugger
              $(".add-to-cart__wrapper").after(
                "<span>Back in stock: " + jQuery.format.date(date, "dd/MM/yyyy") + "</span>",
              );
            } else {
              $(this.selectors.addToCart)
                .addClass("disabled")
                .prop("disabled", true)
                .html(theme.strings.soldOut);
            }
          } else if (this.qty_available <= 0 && this.next_date_available.indexOf("2079") > -1) {
            $(this.selectors.addToCart)
              .addClass("disabled")
              .prop("disabled", true)
              .html(theme.strings.soldOut);
          } else {
            $(this.selectors.addToCart).removeClass("disabled").prop("disabled", false);
            $(this.selectors.addToCartText).html("Add to Basket");
          }
        } else {
          // Sold out, disable the submit button, change text, hide quantity elements
          $(this.selectors.addToCart).addClass("disabled").prop("disabled", true);
          $(this.selectors.addToCartText).html(theme.strings.soldOut);
          $(this.selectors.quantityElements).hide();
        }
        // Regardless of stock, update the product price
        if (membershipProduct) {
          chargeRabbitOptions = JSON.parse(
            document.getElementById("MembershipJson-" + this.settings.sectionId).innerHTML,
          );

          $(this.selectors.productPrice).html(
            "<span class='money'>" +
              Shopify.formatMoney(chargeRabbitOptions[variant.id].amount, moneyFormat) +
              "</span>" +
              chargeRabbitOptions[variant.id].interval,
          );
          $(this.selectors.buttonPrice).html(
            "<span class='money'>" +
              Shopify.formatMoney(chargeRabbitOptions[variant.id].amount, moneyFormat) +
              "</span>" +
              chargeRabbitOptions[variant.id].interval,
          );
          $(this.selectors.addToCartText).html(theme.strings.membership);
        } else {
          if ($("#customer_discount")) {
            discount = $("#customer_discount").val();
          } else {
            discount = 0;
          }
          if (discount > 0) {
            price = variant.price;
            discounted_price = (price / 100) * discount;
            price = Math.round(price - discounted_price);
          } else {
            price = variant.price;
          }
          $(this.selectors.productPrice).html(
            "<span class='money'>" + Shopify.formatMoney(price, moneyFormat) + " Each</span>",
          );

          var quantity,
            quantityLabel = "";
          if ($(this.selectors.quantityInput).length) {
            quantity = $(this.selectors.quantityInput).val();
          } else {
            quantity = 1;
          }

          if (quantity > 1) quantityLabel = "(" + quantity + ")";

          $(this.selectors.buttonPrice).attr("data-item-price", price);
          $(this.selectors.buttonPrice).attr("data-item-quantity", quantity);
          $(this.selectors.buttonPrice).html(
            "<span class='money'>" +
              Shopify.formatMoney(price * quantity, moneyFormat) +
              "</span>&nbsp;" +
              quantityLabel,
          );
        }

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice).html(
            Shopify.formatMoney(variant.compare_at_price, moneyFormat),
          );
          $(this.selectors.comparePrice).parent().parent().show();
        } else {
          $(this.selectors.comparePrice).parent().parent().hide();
        }
      } else {
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        // To only show available variants, implement linked product options:
        //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
        $(this.selectors.addToCart).addClass("disabled").prop("disabled", true);
        $(this.selectors.addToCartText).html(theme.strings.unavailable);
        $(this.selectors.quantityElements).hide();
      }
    },
    stringOverrides: function () {
      // Override defaults in theme.strings with membership overrides
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },
    initSlider: function () {
      var swipeEnable = true;
      if (this.zoomEnable && !Modernizr.touch) {
        swipeEnable = false;
      }

      $(this.selectors.productPhoto).slick({
        adaptiveHeight: false,
        //dots: true,
        swipe: swipeEnable,
        asNavFor: this.selectors.productThumbs,
        //appendDots: $(this.selectors.productThumbs),
        customPaging: function (slider, i) {
          var thumb = $(slider.$slides[i]).data("thumb");
          return '<img src="' + thumb + '">';
        },
      });
      // $(this.selectors.productPhoto).zoom();

      $(this.selectors.productThumbs).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: this.selectors.productPhoto,
        dots: true,
        arrows: false,
        focusOnSelect: true,
      });
      var selector = this.selectors.productPhoto;

      $(this.selectors.image).imagesLoaded(function () {
        $(selector).slick("setPosition");
      });

      if ($(window).width() > 800) {
        $(".easyzoom a").each(function () {
          if (!$(this).attr("href")) {
            $(this).attr("href", $(this).attr("data-href"));
          }
        });
        // Instantiate EasyZoom plugin
        var $easyzoom = $(".easyzoom").easyZoom();
      } else {
        $(".easyzoom a").removeAttr("href");
      }
    },
    productImageZoom: function () {
      if (Modernizr.touch) {
        return;
      }
    },
    productVideo: function () {
      $(".productVideo").magnificPopup({
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        closeBtnInside: false,
        preloader: false,
        fixedContentPos: false,
        iframe: {
          patterns: {
            youtube: {
              src: "//www.youtube.com/embed/%id%?autoplay=1&rel=0&showinfo=0",
            },
          },
        },
      });
    },
    pageModal: function () {
      $(this.selectors.popupButton).magnificPopup({
        type: "inline",
        mainClass: "mfp-fade",
        closeOnBgClick: true,
        closeBtnInside: true,
        closeOnContentClick: false,
        tClose: "x",
        removalDelay: 500,
      });
    },
  });

  return Product;
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

theme.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr("type");
        var currentOption = {};

        if (type === "radio" || type === "checkbox") {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data("index");

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      //this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    },
  });

  return Variants;
})();

theme.Slideshow = (function () {
  function Slideshow(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var slideshow = (this.slideshow = "#slideshow-" + sectionId);
    var $slideshow = (this.$slideshow = $(this.slideshow));

    this.init();
  }

  Slideshow.prototype = _.assignIn({}, Slideshow.prototype, {
    init: function () {
      this.$slideshow.on("init", function (event, slick) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(".slick-current");
        slick.$prevArrow.addClass($currentSlide.data("color"));
        slick.$nextArrow.addClass($currentSlide.data("color"));
      });
      this.$slideshow.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(".slick-current");
        var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');
        if (
          $slider.hasClass("responsive-slideshow") &&
          !$nextSlide.find("img").hasClass("lazyloaded")
        ) {
          $nextSlide.find("img").addClass("lazyload");
        }
        slick.$prevArrow.removeClass(
          "homepage--white homepage--light homepage--splash homepage--dark text--scheme1 text--scheme2 text--scheme3",
        );
        slick.$prevArrow.addClass($nextSlide.data("color"));

        slick.$nextArrow.removeClass(
          "homepage--white homepage--light homepage--splash homepage--dark text--scheme1 text--scheme2 text--scheme3",
        );
        slick.$nextArrow.addClass($nextSlide.data("color"));
      });
      this.$slideshow.slick({
        autoplay: this.$slideshow.data("autoplay"),
        autoplaySpeed: this.$slideshow.data("speed"),
        adaptiveHeight: false,
        dots: false,
      });
    },
    onUnload: function () {
      delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)");
      var slideIndex = $slide.data("slick-index");

      // Go to selected slide, pause autoplay
      $slideshow.slick("slickGoTo", slideIndex).slick("slickPause");
    },
  });
  return Slideshow;
})();

theme.FixedSlideshow = (function () {
  function FixedSlideshow(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var slideshow = (this.slideshow = "#fixed-slideshow-" + sectionId);
    var $slideshow = (this.$slideshow = $(this.slideshow));

    this.init();
  }

  FixedSlideshow.prototype = _.assignIn({}, FixedSlideshow.prototype, {
    init: function () {
      this.$slideshow.on("init", function (event, slick) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(".slick-current");
      });
      this.$slideshow.slick({
        autoplay: this.$slideshow.data("autoplay"),
        autoplaySpeed: this.$slideshow.data("speed"),
        adaptiveHeight: false,
        dots: false,
      });
    },
    onUnload: function () {
      delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)");
      var slideIndex = $slide.data("slick-index");

      // Go to selected slide, pause autoplay
      $slideshow.slick("slickGoTo", slideIndex).slick("slickPause");
    },
  });
  return FixedSlideshow;
})();

theme.Default = (function () {
  function Default(container) {}
  return Default;
})();

function checkSize(
  selector,
  csstocheck,
  cssvaluetocheck,
  moveelement,
  movetowhere,
  movebackelement,
) {
  if ($(selector).css(csstocheck) == cssvaluetocheck) {
    $(moveelement).insertBefore($(movetowhere));
  } else {
    $(moveelement).insertBefore($(movebackelement));
  }
}

function checkinnerdata() {
  if ($(".inner-data").length != 0) {
    checkSize(
      $(".inner-data"),
      "max-width",
      "none",
      ".title-area",
      ".product-single",
      ".product-description",
    );
    checkSize(
      $(".inner-data"),
      "max-width",
      "none",
      ".quantity-selector__wrapper",
      ".add-to-cart__wrapper",
      ".selector-wrapper:first-child",
    );
  }
}

$(document).ready(function () {
  var sections = new theme.Sections();

  sections.register("product", theme.Product);

  sections.register("slideshow", theme.Slideshow);
  sections.register("fixed-slideshow", theme.FixedSlideshow);

  sections.register("index-page", theme.Default);
  sections.register("index-blog", theme.Default);
  sections.register("product-onboarding", theme.Default);
});

$(window).resize(function () {
  checkinnerdata();
});

/*! jquery-dateFormat 18-05-2015 */
var DateFormat = {};
!(function (a) {
  var b = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    c = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    d = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    e = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    f = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    },
    g = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.?\d{0,3}[Z\-+]?(\d{2}:?\d{2})?/;
  a.format = (function () {
    function a(a) {
      return b[parseInt(a, 10)] || a;
    }
    function h(a) {
      return c[parseInt(a, 10)] || a;
    }
    function i(a) {
      var b = parseInt(a, 10) - 1;
      return d[b] || a;
    }
    function j(a) {
      var b = parseInt(a, 10) - 1;
      return e[b] || a;
    }
    function k(a) {
      return f[a] || a;
    }
    function l(a) {
      var b,
        c,
        d,
        e,
        f,
        g = a,
        h = "";
      return (
        -1 !== g.indexOf(".") && ((e = g.split(".")), (g = e[0]), (h = e[e.length - 1])),
        (f = g.split(":")),
        3 === f.length
          ? ((b = f[0]),
            (c = f[1]),
            (d = f[2].replace(/\s.+/, "").replace(/[a-z]/gi, "")),
            (g = g.replace(/\s.+/, "").replace(/[a-z]/gi, "")),
            { time: g, hour: b, minute: c, second: d, millis: h })
          : { time: "", hour: "", minute: "", second: "", millis: "" }
      );
    }
    function m(a, b) {
      for (var c = b - String(a).length, d = 0; c > d; d++) a = "0" + a;
      return a;
    }
    return {
      parseDate: function (a) {
        var b,
          c,
          d = {
            date: null,
            year: null,
            month: null,
            dayOfMonth: null,
            dayOfWeek: null,
            time: null,
          };
        if ("number" == typeof a) return this.parseDate(new Date(a));
        if ("function" == typeof a.getFullYear)
          (d.year = String(a.getFullYear())),
            (d.month = String(a.getMonth() + 1)),
            (d.dayOfMonth = String(a.getDate())),
            (d.time = l(a.toTimeString() + "." + a.getMilliseconds()));
        else if (-1 != a.search(g))
          (b = a.split(/[T\+-]/)),
            (d.year = b[0]),
            (d.month = b[1]),
            (d.dayOfMonth = b[2]),
            (d.time = l(b[3].split(".")[0]));
        else
          switch (
            ((b = a.split(" ")), 6 === b.length && isNaN(b[5]) && (b[b.length] = "()"), b.length)
          ) {
            case 6:
              (d.year = b[5]), (d.month = k(b[1])), (d.dayOfMonth = b[2]), (d.time = l(b[3]));
              break;
            case 2:
              (c = b[0].split("-")),
                (d.year = c[0]),
                (d.month = c[1]),
                (d.dayOfMonth = c[2]),
                (d.time = l(b[1]));
              break;
            case 7:
            case 9:
            case 10:
              (d.year = b[3]), (d.month = k(b[1])), (d.dayOfMonth = b[2]), (d.time = l(b[4]));
              break;
            case 1:
              (c = b[0].split("")),
                (d.year = c[0] + c[1] + c[2] + c[3]),
                (d.month = c[5] + c[6]),
                (d.dayOfMonth = c[8] + c[9]),
                (d.time = l(c[13] + c[14] + c[15] + c[16] + c[17] + c[18] + c[19] + c[20]));
              break;
            default:
              return null;
          }
        return (
          (d.date = d.time
            ? new Date(
                d.year,
                d.month - 1,
                d.dayOfMonth,
                d.time.hour,
                d.time.minute,
                d.time.second,
                d.time.millis,
              )
            : new Date(d.year, d.month - 1, d.dayOfMonth)),
          (d.dayOfWeek = String(d.date.getDay())),
          d
        );
      },
      date: function (b, c) {
        try {
          var d = this.parseDate(b);
          if (null === d) return b;
          for (
            var e,
              f = d.year,
              g = d.month,
              k = d.dayOfMonth,
              l = d.dayOfWeek,
              n = d.time,
              o = "",
              p = "",
              q = "",
              r = !1,
              s = 0;
            s < c.length;
            s++
          ) {
            var t = c.charAt(s),
              u = c.charAt(s + 1);
            if (r) "'" == t ? ((p += "" === o ? "'" : o), (o = ""), (r = !1)) : (o += t);
            else
              switch (((o += t), (q = ""), o)) {
                case "ddd":
                  (p += a(l)), (o = "");
                  break;
                case "dd":
                  if ("d" === u) break;
                  (p += m(k, 2)), (o = "");
                  break;
                case "d":
                  if ("d" === u) break;
                  (p += parseInt(k, 10)), (o = "");
                  break;
                case "D":
                  (k =
                    1 == k || 21 == k || 31 == k
                      ? parseInt(k, 10) + "st"
                      : 2 == k || 22 == k
                        ? parseInt(k, 10) + "nd"
                        : 3 == k || 23 == k
                          ? parseInt(k, 10) + "rd"
                          : parseInt(k, 10) + "th"),
                    (p += k),
                    (o = "");
                  break;
                case "MMMM":
                  (p += j(g)), (o = "");
                  break;
                case "MMM":
                  if ("M" === u) break;
                  (p += i(g)), (o = "");
                  break;
                case "MM":
                  if ("M" === u) break;
                  (p += m(g, 2)), (o = "");
                  break;
                case "M":
                  if ("M" === u) break;
                  (p += parseInt(g, 10)), (o = "");
                  break;
                case "y":
                case "yyy":
                  if ("y" === u) break;
                  (p += o), (o = "");
                  break;
                case "yy":
                  if ("y" === u) break;
                  (p += String(f).slice(-2)), (o = "");
                  break;
                case "yyyy":
                  (p += f), (o = "");
                  break;
                case "HH":
                  (p += m(n.hour, 2)), (o = "");
                  break;
                case "H":
                  if ("H" === u) break;
                  (p += parseInt(n.hour, 10)), (o = "");
                  break;
                case "hh":
                  (e = 0 === parseInt(n.hour, 10) ? 12 : n.hour < 13 ? n.hour : n.hour - 12),
                    (p += m(e, 2)),
                    (o = "");
                  break;
                case "h":
                  if ("h" === u) break;
                  (e = 0 === parseInt(n.hour, 10) ? 12 : n.hour < 13 ? n.hour : n.hour - 12),
                    (p += parseInt(e, 10)),
                    (o = "");
                  break;
                case "mm":
                  (p += m(n.minute, 2)), (o = "");
                  break;
                case "m":
                  if ("m" === u) break;
                  (p += n.minute), (o = "");
                  break;
                case "ss":
                  (p += m(n.second.substring(0, 2), 2)), (o = "");
                  break;
                case "s":
                  if ("s" === u) break;
                  (p += n.second), (o = "");
                  break;
                case "S":
                case "SS":
                  if ("S" === u) break;
                  (p += o), (o = "");
                  break;
                case "SSS":
                  var v = "000" + n.millis.substring(0, 3);
                  (p += v.substring(v.length - 3)), (o = "");
                  break;
                case "a":
                  (p += n.hour >= 12 ? "PM" : "AM"), (o = "");
                  break;
                case "p":
                  (p += n.hour >= 12 ? "p.m." : "a.m."), (o = "");
                  break;
                case "E":
                  (p += h(l)), (o = "");
                  break;
                case "'":
                  (o = ""), (r = !0);
                  break;
                default:
                  (p += t), (o = "");
              }
          }
          return (p += q);
        } catch (w) {
          return console && console.log && console.log(w), b;
        }
      },
      prettyDate: function (a) {
        var b, c, d;
        return (
          ("string" == typeof a || "number" == typeof a) && (b = new Date(a)),
          "object" == typeof a && (b = new Date(a.toString())),
          (c = (new Date().getTime() - b.getTime()) / 1e3),
          (d = Math.floor(c / 86400)),
          isNaN(d) || 0 > d
            ? void 0
            : 60 > c
              ? "just now"
              : 120 > c
                ? "1 minute ago"
                : 3600 > c
                  ? Math.floor(c / 60) + " minutes ago"
                  : 7200 > c
                    ? "1 hour ago"
                    : 86400 > c
                      ? Math.floor(c / 3600) + " hours ago"
                      : 1 === d
                        ? "Yesterday"
                        : 7 > d
                          ? d + " days ago"
                          : 31 > d
                            ? Math.ceil(d / 7) + " weeks ago"
                            : d >= 31
                              ? "more than 5 weeks ago"
                              : void 0
        );
      },
      toBrowserTimeZone: function (a, b) {
        return this.date(new Date(a), b || "MM/dd/yyyy HH:mm:ss");
      },
    };
  })();
})(DateFormat),
  (function (a) {
    a.format = DateFormat.format;
  })(jQuery);

if ($(window).width() < 800) {
  $('*:contains("♥")').each(function () {
    if ($(this).children().length < 1)
      //var thishtml = $(this).html();
      //thishtml.split("♥").join("<i class='fa fa-heart'><i>");
      //$(this).html(thishtml);

      $(this).html($(this).html().replace(/♥/g, "Heart"));
  });
  $('*:contains("❤")').each(function () {
    if ($(this).children().length < 1)
      //var thishtml = $(this).html();
      //thishtml.split("❤").join("<i class='fa fa-heart'><i>");
      //$(this).html(thishtml);

      $(this).html($(this).html().replace(/❤/g, "Heart"));
  });
}

// DBD Modules
class SiteHeader extends HTMLElement {
  constructor() {
    super();

    this.section_wrapper = this.closest("header");
    this.outer_wrapper = this.closest(".site-header__outer");
    this.padding =
      parseInt(window.getComputedStyle(this).getPropertyValue("padding-left").replace("px", "")) *
      2;

    this.nav_track = this.querySelector(".main-navigation__inner");
    this.nav_items = this.querySelectorAll(".main-navigation__parent-item");

    this.min_track_width = 0;
    this.nav_items.forEach((item) => {
      const width = item.getBoundingClientRect().width;
      this.min_track_width = this.min_track_width + width;
    });
  }

  connectedCallback() {
    this.addEventListeners();
    this.collapseNavigation();
  }

  addEventListeners() {
    window.addEventListener("scroll", this.stickyNavigation.bind(this));
    window.addEventListener("resize", this.collapseNavigation.bind(this));
    window.addEventListener("DOMContentLoaded", this.collapseNavigation.bind(this));
  }

  stickyNavigation() {
    const wrapper = this.section_wrapper.getBoundingClientRect();
    if (window.scrollY > wrapper.top) {
      this.outer_wrapper.classList.add("site-header__sticky");
    } else {
      this.outer_wrapper.classList.remove("site-header__sticky");
    }
  }

  collapseNavigation() {
    if (window.innerWidth - this.padding < this.min_track_width) {
      this.outer_wrapper.classList.add("site-header__collapse");
    } else {
      this.outer_wrapper.classList.remove("site-header__collapse");
    }
  }
}

customElements.define("site-header", SiteHeader);

class DropdownMenu extends HTMLElement {
  constructor() {
    super();
    this.is_open = false;
    if (window.matchMedia("(pointer: coarse)").matches) {
      this.is_touch = true;
    }
  }

  connectedCallback() {
    this.toggle_button = this.querySelector("[aria-expanded]");
    this.addEventListeners();
  }

  addEventListeners() {
    if (this.is_touch) {
      this.addEventListener("click", this.clickHandler.bind(this));
      document.addEventListener("click", this.outsideClickHandler.bind(this));
    } else {
      this.addEventListener("mouseenter", this.mouseHandler.bind(this));
      this.addEventListener("mouseleave", this.mouseHandler.bind(this));
    }

    this.addEventListener("keydown", this.keyboardHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.closest('[dropdown-action="toggle"]')) {
      this.toggleMenu();
    }
  }

  outsideClickHandler(e) {
    if (e.target.closest("dropdown-menu") !== this) {
      if (this.is_open) {
        e.preventDefault();
        this.setHidden();
      }
    }
  }

  mouseHandler(e) {
    if (e.type === "mouseenter") {
      this.setVisible();
    } else if (e.type === "mouseleave") {
      this.toggle_button.blur();
      this.setHidden();
    }
  }

  keyboardHandler(e) {
    if (e.key === "Enter" || e.key === "Return") {
      this.toggleMenu();
    }
    if (e.key === "Escape") {
      this.setHidden();
    }
  }

  toggleMenu() {
    if (this.getAttribute("dropdown-view") === "hidden") {
      this.setVisible();
    } else if (this.getAttribute("dropdown-view") === "visible") {
      this.setHidden();
    }
  }

  setHidden() {
    this.is_open = false;
    this.setAttribute("dropdown-view", "hidden");
    this.toggle_button.setAttribute("aria-expanded", "false");
  }

  setVisible() {
    this.is_open = true;
    this.setAttribute("dropdown-view", "visible");
    this.toggle_button.setAttribute("aria-expanded", "true");
  }
}

customElements.define("dropdown-menu", DropdownMenu);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.is_open = false;
  }
  connectedCallback() {
    this.addEventListeners();
  }
  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("keydown", this.keyboardHandler.bind(this));
  }
  clickHandler(e) {
    const action_target =
      e.target.closest("[modal-dialog-action]")?.getAttribute("modal-dialog-action") || null;
    if (action_target === "open") {
      e.preventDefault();
      this.openModal();
    } else if (action_target === "close" || !e.target.closest(".modal-main__inner")) {
      e.preventDefault();
      this.closeModal();
    }
  }
  keyboardHandler(e) {
    if ((e.key === "Escape" || e.keyCode === 27) && this.is_open === true) {
      this.closeModal();
    }
  }
  openModal() {
    this.is_open = true;
    this.setAttribute("aria-hidden", "false");
    this.setAttribute("modal-dialog-view", "visible");
  }
  closeModal() {
    this.is_open = false;
    this.setAttribute("aria-hidden", "true");
    this.setAttribute("modal-dialog-view", "hidden");
  }
}

customElements.define("modal-dialog", ModalDialog);

class ImageDownload extends ModalDialog {
  constructor() {
    super();
    this.checkboxes = this.querySelectorAll(".account-order__product-select");
    this.selectToggle = this.querySelector('[modal-dialog-event="download-images-select"]');
    this.downloadButton = this.querySelector('[modal-dialog-event="download-images-submit"]');
  }

  addEventListeners() {
    super.addEventListeners();
    this.addEventListener("input", this.inputHandler.bind(this));
  }

  inputHandler(e) {
    let hasChecked = false;
    for (const checkbox of this.checkboxes) {
      if (checkbox.checked === true) {
        hasChecked = true;
        break;
      }
    }
    if (!hasChecked) {
      this.downloadButton.disabled = true;
    } else {
      this.downloadButton.disabled = false;
    }
  }

  clickHandler(e) {
    super.clickHandler(e);
    if (e.target.closest("[modal-dialog-event]") === this.selectToggle) {
      this.selectAllToggle();
    }
    if (
      e.target.closest("[modal-dialog-event]")?.getAttribute("modal-dialog-event") ===
      "download-images-submit"
    ) {
      this.packageDownloads();
    }
  }

  closeModal() {
    super.closeModal();
    this.selectAllToggle("deselect");
  }

  selectAllToggle(type) {
    if (type && type == "deselect") {
      this.checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    } else {
      this.checkboxes.forEach((checkbox) => {
        checkbox.checked = true;
      });
    }
    this.dispatchEvent(new Event("input"));
  }

  async fetchImageBinary(url) {
    return new Promise(function (resolve, reject) {
      JSZipUtils.getBinaryContent(url, function (err, data) {
        if (err) {
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  }

  async packageDownloads() {
    const zip = new JSZip();
    const directory = zip.folder("TalkingTablesDownload");

    this.selectedItems = [];
    Array.from(this.checkboxes).forEach((checkbox) => {
      const parent = checkbox.closest(".account-order__product");
      if (checkbox.checked === true) {
        this.selectedItems.push({
          title: parent.dataset.title,
          images: JSON.parse(parent.dataset.images),
        });
      }
    });

    for (const product of this.selectedItems) {
      for (const image of product.images) {
        const fileSubstring = image.substring(image.lastIndexOf("/") + 1);
        const fileName = fileSubstring.split("?")[0].toLowerCase();
        if (fileName.indexOf("private") <= 0) {
          directory.file(product.title + "/" + fileName, this.fetchImageBinary(image), {
            binary: true,
          });
        }
      }
    }

    try {
      const blob = await zip.generateAsync({ type: "blob" }, () => {
        this.downloadButton.innerText = "Gathering your files";
        this.downloadButton.disabled = true;
      });
      saveAs(blob, "TalkingTablesDownload.zip");
      this.downloadButton.innerText = "Finished";
    } catch (error) {
      console.log(error);
      this.downloadButton.innerText = "Something went wrong";
    } finally {
      setTimeout(() => {
        // this.closeModal();
        // this.selectAllToggle("deselect");
        this.downloadButton.innerText = "Download";
        this.downloadButton.disabled = false;
      }, 2000);
    }
  }
}

customElements.define("image-download", ImageDownload);

class ProductImageDownload extends HTMLElement {
  constructor() {
    super();
    this.downloadButton = this.querySelector('[download-images-event="download-images-submit"]');
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
  }

  clickHandler(e) {
    if (
      e.target.closest("[download-images-event]")?.getAttribute("download-images-event") ===
      "download-images-submit"
    ) {
      this.packageDownloads();
    }
  }

  async fetchImageBinary(url) {
    return new Promise(function (resolve, reject) {
      JSZipUtils.getBinaryContent(url, function (err, data) {
        if (err) {
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  }

  async packageDownloads() {
    const zip = new JSZip();
    const directory = zip.folder("TalkingTablesDownload");

    this.selectedItems = [];
    const productElement = this.querySelector(".image-download__product");
    this.selectedItems.push({
      title: productElement.dataset.title,
      images: JSON.parse(productElement.dataset.images),
    });

    for (const product of this.selectedItems) {
      for (const image of product.images) {
        const fileSubstring = image.substring(image.lastIndexOf("/") + 1);
        const fileName = fileSubstring.split("?")[0].toLowerCase();
        if (fileName.indexOf("private") <= 0) {
          directory.file(product.title + "/" + fileName, this.fetchImageBinary(image), {
            binary: true,
          });
        }
      }
    }

    try {
      const blob = await zip.generateAsync({ type: "blob" }, () => {
        this.downloadButton.innerText = "Gathering your files";
        this.downloadButton.disabled = true;
      });
      saveAs(blob, "TalkingTablesDownload.zip");
      this.downloadButton.innerText = "Finished";
    } catch (error) {
      console.log(error);
      this.downloadButton.innerText = "Something went wrong";
    } finally {
      setTimeout(() => {
        this.downloadButton.innerText = "Download product images";
        this.downloadButton.disabled = false;
      }, 2000);
    }
  }
}

customElements.define("product-image-download", ProductImageDownload);

class RepeatOrder extends ModalDialog {
  constructor() {
    super();

    this.main_message = this.querySelector("[modal-main-message]");
    this.unavailable_message = this.querySelector("[modal-unavailable-message]");
    this.alternative_message = this.querySelector("[modal-alternative-message]");
  }

  addEventListeners() {
    super.addEventListeners();
  }

  clickHandler(e) {
    super.clickHandler(e);
    if (e.target.getAttribute("modal-dialog-action") === "open") {
      if (!this.unavailable_message) {
        this.triggerReorder();
      }
    }
    if (e.target.getAttribute("modal-dialog-event") === "repeat-order-clear") {
      this.toggleMessage();
      this.clearCart();
    }
    if (e.target.getAttribute("modal-dialog-event") === "repeat-order-combine") {
      this.toggleMessage();
      this.continueReorder();
    }
  }

  async triggerReorder() {
    const cart_check = await this.checkCart();
    if (!cart_check) {
      this.toggleMessage("alt");
    } else {
      this.continueReorder();
    }
  }

  async checkCart() {
    try {
      const res = await fetch("/cart.js");
      if (!res.ok) {
        throw new Error("Something went wrong");
      }
      const data = await res.json();
      if (data.item_count > 0) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async continueReorder() {
    const form_inputs = this.querySelectorAll("form input");
    const form_data = {};
    for (const input of form_inputs) {
      let current = 0;
      if (form_data[input.dataset.id]?.quantity) {
        current = form_data[input.dataset.id].quantity;
      }
      form_data[input.dataset.id] = { properties: {} };
      form_data[input.dataset.id].quantity = current + +input.dataset.quantity;
      form_data[input.dataset.id].properties._multiples = +input.dataset.multiples;
      form_data[input.dataset.id].productId = +input.dataset.productId;
    }
    const items = [];
    for (const [key, value] of Object.entries(form_data)) {
      items.push({
        id: +key,
        quantity: value.quantity,
        properties: { ...value.properties },
        product_id: value.productId,
      });
    }
    const data = {
      type: "add",
      source: "repeat-order",
      items,
    };
    updateCart(data);
    this.closeModal();
  }

  async clearCart() {
    const data = {
      items: [],
      source: "clear-cart",
      type: "clear",
    };
    await updateCart(data);
    this.continueReorder();
  }

  closeModal() {
    super.closeModal();
    this.toggleMessage();
  }

  toggleMessage(type) {
    if (type === "alt") {
      this.main_message.setAttribute("aria-hidden", "true");
      this.alternative_message.setAttribute("aria-hidden", "false");
    } else {
      this.main_message.setAttribute("aria-hidden", "false");
      this.alternative_message.setAttribute("aria-hidden", "true");
    }
  }
}

customElements.define("repeat-order", RepeatOrder);

class AccountForm extends HTMLElement {
  constructor() {
    super();
    this.form_type = this.getAttribute("form-type");
    this.form_targets = this.querySelectorAll("[data-form-target]");
    this.form_fields = this.querySelectorAll("input");
  }
  connectedCallback() {
    this.addEventListeners();
    if (this.form_type === "existing_address") {
      this.setSelectedCountry();
    } else {
      this.setReturnURL();
    }
  }
  addEventListeners() {
    this.addEventListener("submit", this.uiSubmit.bind(this));
    this.addEventListener("input", this.updateField.bind(this));
    this.addEventListener("click", this.clickHandler.bind(this));
  }
  clickHandler(e) {
    if (
      e.target.dataset.formAction === "toggle" ||
      e.target.closest("[data-form-action]").dataset.formAction === "toggle"
    ) {
      this.toggleForms();
    }
    if (
      e.target.dataset.formAction === "set_default" ||
      e.target.closest("[data-form-action]").dataset.formAction === "set_default"
    ) {
      this.setDefaultAddress(e);
    }
  }
  toggleForms() {
    this.form_targets.forEach((form) => {
      if (form.getAttribute("aria-hidden") === "true") {
        form.setAttribute("aria-hidden", "false");
      } else {
        form.setAttribute("aria-hidden", "true");
      }
    });
  }

  // Login & register functions
  setReturnURL() {
    const return_input = this.querySelector('input[name="checkout_url"]');
    const params = new URLSearchParams(window.location.search);
    const return_url = params.get("return_url");
    if (!return_input || !return_url) return;
    return_input.value = return_url;
  }

  updateField(e) {
    e.target.setAttribute("value", e.target.value);
    if (e.target.value !== "") {
      e.target.removeAttribute("aria-invalid");
    }
  }
  uiSubmit(e) {
    e.submitter.classList.add("btn-elem--loading");
  }

  // Address functions
  setSelectedCountry() {
    const country_field = this.querySelector("[data-address-country-select]");
    const set_country = country_field.dataset.default;
    country_field.querySelector(`[value="${set_country}"]`).selected = true;
  }
  setDefaultAddress(e) {
    e.target.classList.add("btn-elem--loading");
    const edit_form = this.querySelector(".account-form__form");
    edit_form.querySelector('[name="address[default]"]').checked = true;
    edit_form.submit();
  }
}
customElements.define("account-form", AccountForm);

class DrawerNavigation extends DropdownMenu {
  constructor() {
    super();

    this.menu_parents = this.querySelectorAll(".drawer-navigation__parent-item");
    this.menu_children = this.querySelectorAll(".drawer-navigation__child-item");
  }

  connectedCallback() {
    this.toggle_button = this.querySelector("[aria-expanded]");
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("click", this.outsideClickHandler.bind(this));
    if (!this.is_touch) {
      this.addEventListener("mouseenter", this.mouseHandler.bind(this));
      this.addEventListener("mouseleave", this.mouseHandler.bind(this));
    }

    this.addEventListener("keydown", this.keyboardHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.closest(".drawer-navigation__button")) {
      const btn = e.target.closest(".drawer-navigation__button");
      this.scrollToTop(btn);
    }
    if (e.target.closest(".drawer-navigation__backlink")) {
      const btn = e.target.closest(".drawer-navigation__backlink");
      this.scrollToTop(btn);
    }
    if (e.target.closest('.menu__button[dropdown-action="toggle"]')) {
      this.toggleMenu();
    }
    if (
      e.target.getAttribute("aria-expanded") ||
      e.target.parentElement.getAttribute("aria-expanded")
    ) {
      e.preventDefault();
      e.target.getAttribute("aria-expanded")
        ? e.target.setAttribute("aria-expanded", "true")
        : e.target.parentElement.setAttribute("aria-expanded", "true");
    }
    if (e.target.closest(".drawer-navigation__child-backlink-wrapper")) {
      e.preventDefault();
      const parent = e.target.closest(".drawer-navigation__parent-menu");
      parent.previousElementSibling.setAttribute("aria-expanded", "false");
    }
    if (e.target.closest(".drawer-navigation__grandchild-backlink-wrapper")) {
      e.preventDefault();
      const parent = e.target.closest(".drawer-navigation__child-menu");
      parent.previousElementSibling.setAttribute("aria-expanded", "false");
    }
  }

  scrollToTop(btn) {
    btn.closest("#drawer-menu").scrollTop = 0;
  }

  outsideClickHandler(e) {
    if (e.target.closest("drawer-navigation") !== this) {
      if (this.is_open) {
        e.preventDefault();
        this.setHidden();
        this.closeAllMenus();
      }
    }
  }

  keyboardHandler(e) {
    if (e.key === "Enter" || e.key === "Return") {
      if (e.target.getAttribute("aria-expanded")) {
        e.preventDefault();
        e.target.setAttribute("aria-expanded", "true");
      }
    }
    if (e.key === "Escape") {
      this.closeAllMenus();
    }
  }

  toggleMenu() {
    super.toggleMenu();
    if (this.getAttribute("dropdown-view") === "visible") {
      this.closeAllMenus();
    }
  }

  closeAllMenus() {
    this.menu_parents.forEach((parent) => {
      parent.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    });
    this.menu_children.forEach((child) => {
      child.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    });
  }
}
customElements.define("drawer-navigation", DrawerNavigation);

class MainNavigation extends HTMLElement {
  constructor() {
    super();

    this.parents = this.querySelectorAll(".main-navigation__parent-item");
    this.menu_links = this.querySelectorAll(".main-navigation__parent-menu a[data-image]");
    this.is_touch = false;
    if (window.matchMedia("(pointer: coarse)").matches) {
      this.is_touch = true;
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.parents.forEach((parent) => {
      if (this.is_touch) {
        parent.addEventListener("click", this.clickHandler.bind(this));
      } else {
        parent.addEventListener("mouseenter", this.mouseHandler.bind(this));
        parent.addEventListener("mouseleave", this.mouseHandler.bind(this));
      }
    });
    this.menu_links.forEach((link) => {
      if (!this.is_touch) {
        link.addEventListener("mouseenter", this.previewHandler.bind(this));
      }
    });

    if (this.is_touch) {
      document.addEventListener("click", this.outsideClickHandler.bind(this));
    }

    this.addEventListener("keydown", this.keyboardHandler.bind(this));
  }

  clickHandler(e) {
    if (
      e.target.classList.contains("main-navigation__parent-button") &&
      e.target.getAttribute("aria-expanded") === "false"
    ) {
      e.preventDefault();
      this.closeAllMenus();
      e.target.setAttribute("aria-expanded", "true");
    }
  }

  outsideClickHandler(e) {
    if (e.target.closest("main-navigation") !== this) {
      this.closeAllMenus();
    }
  }

  mouseHandler(e) {
    if (e.type === "mouseleave") {
      e.target.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    } else if (e.type === "mouseenter") {
      e.target.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "true");
    }
  }

  keyboardHandler(e) {
    if (e.key === "Enter" || e.key === "Return") {
      if (e.target.getAttribute("aria-expanded") === "false") {
        e.preventDefault();
        this.closeAllMenus();
        e.target.setAttribute("aria-expanded", "true");
      }
    }
    if (e.key === "Escape") {
      this.parents.forEach((parent) => {
        parent.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
      });
    }
  }

  previewHandler(e) {
    const image_url = e.target.dataset.image;
    const preview_container = e.target
      .closest(".main-navigation__parent-menu")
      .querySelector(".previews-active");
    if (!image_url || !preview_container) return;
    let preview_image = preview_container.querySelector("img");
    if (!preview_image) {
      preview_image = document.createElement("img");
      preview_image.setAttribute("loading", "lazy");
      preview_image.classList.add("luc-img__asset");
      preview_container.querySelector(".luc-img").appendChild(preview_image);
    }
    preview_image.src = image_url;
  }

  closeAllMenus() {
    this.parents.forEach((parent) => {
      parent.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    });
  }
}
customElements.define("main-navigation", MainNavigation);

class StaticSearch extends HTMLElement {
  constructor() {
    super();
    this.search = {
      query: this.getAttribute("search-query"),
    };
    this.inputWrapper = this.querySelector(".input-wrapper");
  }

  connectedCallback() {
    this.addEventListeners();
    this.init();
  }

  addEventListeners() {
    this.input = this.querySelector('input[type="search"]');
    this.input.addEventListener("focusin", this.setActive.bind(this));
    this.input.addEventListener("input", (event) => {
      this.inputChange(event);
    });
    this.querySelector("form").addEventListener("submit", this.triggerResultsRefresh.bind(this));

    document.addEventListener("click", this.clickHandler.bind(this));
    this.clear = this.querySelector(".input-clear");
  }

  clickHandler(e) {
    if (e.target === this.clear || e.target.closest(".input-clear")) {
      e.preventDefault();
      this.clearResults();
      return;
    }
    if (!e.target.closest("static-search")) {
      this.unsetActive();
      return;
    }
  }

  inputChange() {
    const query = this.input.value.trim();
    this.search.query = query;
    this.toggleClearButton();
    this.setAttribute("search-query", query);
  }

  triggerResultsRefresh(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const searchParams = new URLSearchParams(formData).toString();
    const event = new CustomEvent("results:refresh:start", {
      detail: {
        params: searchParams,
        type: "q",
      },
    });
    document.dispatchEvent(event);
  }

  toggleClearButton() {
    if (this.input.value !== "") {
      this.querySelector(".input-clear").classList.add("input-clear--visible");
    } else {
      this.querySelector(".input-clear").classList.remove("input-clear--visible");
    }
  }

  clearResults() {
    this.input.value = "";
    this.input.dispatchEvent(new Event("input"));
    this.input.focus();
  }

  setActive() {
    this.inputWrapper.classList.add("input-wrapper--active");
  }

  unsetActive() {
    if (this.input.value === "") {
      this.inputWrapper.classList.remove("input-wrapper--active");
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  init() {
    if (this.input.value !== "") {
      this.inputWrapper.classList.add("input-wrapper--active");
    }
  }
}

customElements.define("static-search", StaticSearch);

class RangeSlider extends HTMLElement {
  constructor() {
    super();

    this.mouseDown = false;
    this.startX = 0;
    this.handle = null;
    this.minHandle = null;
    this.maxHandle = null;
  }

  addEventListeners() {
    this.addEventListener("mousemove", this.dragHandler.bind(this));
    this.addEventListener("touchmove", this.dragHandler.bind(this));

    this.addEventListener("mousedown", this.startHandler.bind(this));
    this.addEventListener("touchstart", this.startHandler.bind(this));

    this.addEventListener("mouseup", this.endHandler.bind(this));
    this.addEventListener("touchend", this.endHandler.bind(this));
    this.addEventListener("mouseleave", this.endHandler.bind(this));

    document.addEventListener("range:set", this.setHandlePositions.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("mousemove", this.dragHandler.bind(this));
    this.removeEventListener("touchmove", this.dragHandler.bind(this));

    this.removeEventListener("mousedown", this.startHandler.bind(this));
    this.removeEventListener("touchstart", this.startHandler.bind(this));

    this.removeEventListener("mouseup", this.endHandler.bind(this));
    this.removeEventListener("touchend", this.endHandler.bind(this));
    this.removeEventListener("mouseleave", this.endHandler.bind(this));

    document.removeEventListener("range:set", this.setHandlePositions.bind(this));
  }

  connectedCallback() {
    this.minHandle = this.querySelector("#range-slider-min");
    this.maxHandle = this.querySelector("#range-slider-max");
    this.handleWidth = this.minHandle.offsetWidth;
    this.trackSize = this.offsetWidth - this.handleWidth;
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  dragHandler(e) {
    if (!this.mouseDown) return;
    let pageX = 0;
    if (e.pageX) {
      pageX = e.pageX;
    } else {
      pageX = e.touches[0].pageX;
    }
    const x = pageX - e.currentTarget.offsetLeft;
    let percentage = 0;
    if (this.handle.id === "range-slider-min" && x < this.handleWidth / 2) {
      this.handle.style.left = `${this.handleWidth / 2}px`;
      percentage = 0;
    } else if (
      this.handle.id === "range-slider-max" &&
      x > this.offsetWidth - this.handleWidth / 2
    ) {
      this.handle.style.left = `${this.offsetWidth - this.handleWidth / 2}px`;
      percentage = 100;
    } else {
      if (
        this.handle.id === "range-slider-min" &&
        x >= this.maxHandle.offsetLeft - this.handleWidth / 2
      ) {
        this.handle.style.left = `${this.maxHandle.offsetLeft - this.handleWidth / 2}px`;
      } else if (
        this.handle.id === "range-slider-max" &&
        x <= this.minHandle.offsetLeft + this.handleWidth * 1.5
      ) {
        this.handle.style.left = `${this.minHandle.offsetLeft + this.handleWidth * 1.5}px`;
      } else {
        this.handle.style.left = `${x}px`;
      }
      percentage = (this.handle.offsetLeft / this.trackSize) * 100;
    }

    // event to update the min and max values as percentages
    this.sendUpdatedHandleValue(this.handle.id, percentage);
  }

  startHandler(e) {
    if (!e.target.classList.contains("range-slider__handle")) return;

    this.mouseDown = true;
    let pageX = 0;
    if (e.pageX) {
      pageX = e.pageX;
    } else {
      pageX = e.touches[0].pageX;
    }
    this.startX = pageX - e.target.offsetLeft;
    this.handle = e.target;
  }

  endHandler(e) {
    if (this.mouseDown) {
      const event = new CustomEvent("range:complete");
      document.dispatchEvent(event);
    }
    this.mouseDown = false;
  }

  setHandlePositions(e) {
    const {
      detail: { min, max },
    } = e;

    const maxPosition = (max.current / max.limit) * 100;
    const minPosition = (min.current / max.limit) * 100;

    this.maxHandle.style.left = `${(this.trackSize / 100) * maxPosition + this.handleWidth / 2}px`;
    this.minHandle.style.left = `${(this.trackSize / 100) * minPosition + this.handleWidth / 2}px`;
  }

  sendUpdatedHandleValue(id, percentage) {
    const event = new CustomEvent("range:update", {
      detail: {
        id,
        percentage,
      },
    });
    document.dispatchEvent(event);
  }
}

customElements.define("range-slider", RangeSlider);

class ResultsGrid extends HTMLElement {
  constructor() {
    super();

    this.showCount = this.getAttribute("count-active") === "true" ? true : false;
    this.showSorting = this.getAttribute("sorting-active") === "true" ? true : false;
    this.showFilters = this.getAttribute("filters-active") === "true" ? true : false;
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("results:refresh:start", this.changeHandler.bind(this));
    window.addEventListener("popstate", () => {
      window.location.reload();
    });
    document.addEventListener("DOMContentLoaded", () => {
      const topBar = document.querySelector(".announcement-bar");
      const header = document.querySelector(".site-header");
      this.headerHeight = header?.offsetHeight + topBar?.offsetHeight;
    });
  }

  removeEventListeners() {
    this.removeEventListener("click", this.clickHandler.bind(this));
    document.removeEventListener("results:refresh:start", this.changeHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.closest(".main-pagination__wrapper")) {
      this.paginationClick(e);
      return;
    }
    if (e.target.dataset.clear && e.target.closest(".results-grid__empty")) {
      const event = new CustomEvent("filters:clear", {
        detail: {
          changeFilter: e.target,
        },
      });
      document.dispatchEvent(event);
    }
  }

  changeHandler(e) {
    this.createSearchString(e);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  paginationClick(e) {
    e.preventDefault();
    const url = e.target.href;
    if (!url) return;
    const paginationUrl = new URL(e.target.href);
    const filteredParams = Array.from(paginationUrl.searchParams.entries()).filter((param) => {
      return param[0].indexOf("page") === 0;
    });
    const event = new CustomEvent("results:refresh:start", {
      detail: {
        params: new URLSearchParams(filteredParams),
        type: "page",
      },
    });
    document.dispatchEvent(event);
  }

  createSearchString(e) {
    const type = e.detail.type;
    const currentSearchParams = Array.from(new URLSearchParams(window.location.search).entries());
    const newSearchParams = new URLSearchParams(e.detail.params);
    const filteredParams = currentSearchParams.filter((param) => {
      if (type !== "page") {
        return param[0].indexOf(type) === -1 && param[0].indexOf("page") === -1;
      } else {
        return param[0].indexOf(type) === -1;
      }
    });
    const searchString = new URLSearchParams([...filteredParams, ...newSearchParams]).toString();
    this.refreshResults(`${window.location.pathname}?${searchString}`);
  }

  updateHistory(url) {
    const currentUrl = new URL(`${window.location.origin}${url}`);
    history.pushState(null, null, currentUrl);
  }

  async refreshResults(url) {
    this.classList.add("results-grid--loading");
    let thisTop = this.offsetTop;
    if (window.innerWidth <= 767) {
      thisTop = this.offsetTop - this.headerHeight;
    }
    if (window.scrollY > thisTop) {
      window.scrollTo({
        top: thisTop,
        behavior: "smooth",
      });
    }
    try {
      const response = await fetch(`${url}`);
      const data = await response.text();
      const dataHtml = document.createElement("div");
      dataHtml.innerHTML = data;

      const products = dataHtml.querySelector(".results-grid__products");
      const pagination = dataHtml.querySelector(".results-grid__pagination");

      const productElement = this.querySelector(".results-grid__products");
      const paginationElement = this.querySelector(".results-grid__pagination");

      productElement.innerHTML = products.innerHTML;
      paginationElement.innerHTML = pagination.innerHTML;

      if (this.showCount) {
        const productsCount = dataHtml.querySelector(".results-grid__count");
        const productsCountElement = this.querySelector(".results-grid__count");
        productsCountElement.innerHTML = productsCount.innerHTML;
      }
      if (this.showFilters) {
        const dataFiltersElem = dataHtml.querySelector(".results-grid__filters");
        const currentFiltersElem = this.querySelector(".results-grid__filters");

        if (
          !dataFiltersElem.classList.contains("results-grid__filters--hide") &&
          currentFiltersElem.classList.contains("results-grid__filters--hide")
        ) {
          // if refreshed doesnt have hide class and current page has hide, indicates a matching search so insert filters
          currentFiltersElem.innerHTML = dataFiltersElem.innerHTML;
          currentFiltersElem.classList.remove("results-grid__filters--hide");
        }
        if (!currentFiltersElem.classList.contains("results-grid__filters--hide")) {
          const filters = dataHtml.querySelector(
            ".results-grid__filters .results-filters__form .form__content",
          ).outerHTML;
          const mobileButtonCount = dataHtml.querySelector(".results-filters__footer-buttons");
          const mobileButtonCountElement = this.querySelector(".results-filters__footer-buttons");
          productElement.classList.remove("results-grid__products--full");
          mobileButtonCountElement.innerHTML = mobileButtonCount.innerHTML;

          const event = new CustomEvent("results:refresh:success", {
            detail: {
              filter_data: filters,
            },
          });
          document.dispatchEvent(event);
        }
      }

      this.updateHistory(url);
    } catch (error) {
      console.log(error);
    } finally {
      this.classList.remove("results-grid--loading");
    }
  }
}

customElements.define("results-grid", ResultsGrid);

class ResultsFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListeners();
    this.windowWidth = 0;
    this.detectDevice();

    if (!this.querySelector(".price__range")) return;

    this.minPriceElem = this.querySelector('.price__range-from input[type="number"]');
    this.maxPriceElem = this.querySelector('.price__range-to input[type="number"]');
    this.minPrice = parseInt(this.minPriceElem.getAttribute("min"));
    this.maxPrice = parseInt(this.maxPriceElem.getAttribute("max"));

    this.setRangeHandles();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  detectDevice() {
    if (window.innerWidth !== this.windowWidth) {
      if (window.innerWidth <= 768) {
        this.setAttribute("aria-expanded", "false");
        this.resetDrawerState();
      } else {
        this.setAttribute("aria-expanded", "true");
      }
      this.windowWidth = window.innerWidth;
    }
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    window.addEventListener("resize", this.detectDevice.bind(this));
    document.addEventListener("results:refresh:success", this.eventHandler.bind(this));
    document.addEventListener("filters:clear", this.clickHandler.bind(this));

    // custom event listener for detatched filter drawer button
    document.addEventListener("filters:open", this.openFilterDrawer.bind(this));
    // custom event listeners for range slider
    document.addEventListener("range:update", this.updatePriceRange.bind(this));

    // auto price change grid refresh
    // this.addEventListener('input', this.inputHandler.bind(this));
    // document.addEventListener('range:complete', this.applyPriceRange.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("click", this.clickHandler.bind(this));
    window.removeEventListener("resize", this.detectDevice.bind(this));
    document.removeEventListener("results:refresh:success", this.eventHandler.bind(this));
    document.removeEventListener("filters:clear", this.clickHandler.bind(this));

    // custom event listener for detatched filter drawer button
    document.removeEventListener("filters:open", this.openFilterDrawer.bind(this));
    // custom event listeners for range slider
    document.removeEventListener("range:update", this.updatePriceRange.bind(this));

    // auto price change grid refresh
    // this.removeEventListener('input', this.inputHandler.bind(this));
    // document.removeEventListener('range:complete', this.applyPriceRange.bind(this));
  }

  clickHandler(e) {
    if (e.detail?.changeFilter || e.target.dataset.filter || e.target.dataset.clear) {
      const target = e.detail.changeFilter ? e.detail.changeFilter : e.target;
      if (target.dataset.active) {
        e.preventDefault();
        // uncheck if active filter is clicked
        if (target.dataset.filter !== "price") {
          this.querySelector(
            `[type="checkbox"][data-filter="${target.dataset.filter}"][value="${target.dataset.value}"]`,
          ).checked = false;
        } else {
          this.querySelectorAll(`[type="number"]`).forEach((filter) => {
            filter.value = "";
            filter.setAttribute("name", "");
          });
        }
      }
      if (target.dataset.clear) {
        e.preventDefault();
        this.querySelectorAll(`[type="checkbox"]`).forEach((filter) => {
          filter.checked = false;
        });
        this.querySelectorAll(`[type="number"]`).forEach((filter) => {
          filter.value = "";
          filter.setAttribute("name", "");
        });
      }
      this.checkPriceFilters();
      this.debounce(() => this.changeFilter());
      return;
    }
    if (e.target.closest(".btn-elem--price")) {
      e.preventDefault();
      this.applyPriceRange();
    }
    if (e.target.classList.contains("filter__header") || e.target.closest(".filter-option__back")) {
      // toggle filter list dropdown
      const target = e.target.closest(".filter").querySelector(".filter__header");
      const toggle = target.ariaExpanded === "true" ? true : false;
      target.ariaExpanded = !toggle;
      return;
    }
    if (e.target.classList.contains("filter__more")) {
      e.preventDefault();
      const toggle = e.target.ariaExpanded === "true" ? true : false;
      e.target.ariaExpanded = !toggle;
      e.target.textContent === theme.strings.show_more
        ? (e.target.textContent = theme.strings.show_less)
        : (e.target.textContent = theme.strings.show_more);
      return;
    }
    if (e.target.dataset.action === "open-filter-drawer") {
      this.openFilterDrawer();
      return;
    }
    if (e.target.dataset.action === "close-filter-drawer") {
      this.closeFilterDrawer();
      return;
    }
  }

  inputHandler(e) {
    if (!e.target.dataset.priceFilter) return;
    this.debounce(() => {
      this.applyPriceRange();
    }, 1000);
  }

  eventHandler(e) {
    const fragment = document.createElement("div");
    fragment.innerHTML = e.detail.filter_data;
    const filters = fragment.querySelectorAll("[data-filter]");
    filters.forEach((filter) => {
      const element = this.querySelector(
        `[data-filter="${filter.dataset.filter}"][value="${filter.value}"]`,
      );
      const parent = element.parentElement;
      element.dataset.count = filter.dataset.count;
      filter.dataset.count <= 0
        ? parent.classList.add("filter-option--nocount")
        : parent.classList.remove("filter-option--nocount");
      element.nextElementSibling.querySelector(".filter-option__count").textContent =
        `(${filter.dataset.count})`;
    });
  }

  openFilterDrawer() {
    this.setAttribute("aria-expanded", "true");
  }

  closeFilterDrawer() {
    this.setAttribute("aria-expanded", "false");
    this.debounce(() => {
      this.resetDrawerState();
    });
  }

  checkPriceFilters(e) {
    this.minPriceElem.value === "" ? (this.minPriceElem.value = this.minPrice) : null;
    this.maxPriceElem.value === "" ? (this.maxPriceElem.value = this.maxPrice) : null;

    const minElemValue = parseInt(this.minPriceElem.value);
    const maxElemValue = parseInt(this.maxPriceElem.value);

    minElemValue < this.minPrice ? (this.minPriceElem.value = this.minPrice) : null;
    minElemValue > this.maxPrice ? (this.minPriceElem.value = this.maxPrice) : null;
    maxElemValue < this.minPrice ? (this.maxPriceElem.value = this.minPrice) : null;
    maxElemValue > this.maxPrice ? (this.maxPriceElem.value = this.maxPrice) : null;

    minElemValue > maxElemValue ? (this.maxPriceElem.value = this.minPriceElem.value) : null;

    if (minElemValue === this.minPrice && maxElemValue === this.maxPrice) {
      this.minPriceElem.setAttribute("name", "");
      this.maxPriceElem.setAttribute("name", "");
    } else {
      this.minPriceElem.setAttribute("name", this.minPriceElem.dataset.priceFilter);
      this.maxPriceElem.setAttribute("name", this.maxPriceElem.dataset.priceFilter);
    }
    this.setRangeHandles();
  }

  setRangeHandles() {
    const event = new CustomEvent("range:set", {
      detail: {
        min: {
          current:
            this.minPriceElem.value !== "" ? parseInt(this.minPriceElem.value) : this.minPrice,
          limit: this.minPrice,
        },
        max: {
          current:
            this.maxPriceElem.value !== "" ? parseInt(this.maxPriceElem.value) : this.maxPrice,
          limit: this.maxPrice,
        },
      },
    });
    document.dispatchEvent(event);
  }

  updatePriceRange(e) {
    const { id, percentage } = e.detail;
    if (!this.querySelector(".filter-option--price")) return;

    const filter = this.querySelector(
      id === "range-slider-min"
        ? '.price__range-from input[type="number"]'
        : '.price__range-to input[type="number"]',
    );
    const maxValue = filter.getAttribute("max");

    filter.value = Math.round((percentage / 100) * maxValue);
  }

  applyPriceRange() {
    this.checkPriceFilters();
    this.changeFilter();
  }

  changeFilter() {
    const filtersForm = new FormData(this.querySelector("form"));
    const searchParamsArr = [];
    for (const [key, value] of filtersForm) {
      if (key.indexOf("filter") !== -1) {
        searchParamsArr.push(`${key}=${encodeURIComponent(value)}`);
      }
    }
    const searchParamsStr = searchParamsArr.join("&");
    // emit custom event with search string as payload
    const filterChangeEvent = new CustomEvent("results:refresh:start", {
      detail: {
        params: searchParamsStr,
        type: "filter",
      },
    });
    document.dispatchEvent(filterChangeEvent);
    this.updateActiveFilters(filtersForm);
  }

  createActiveFilterButton(filter) {
    const button = document.createElement("button");
    let attributes = {};
    let label = "";
    if (typeof filter[0] === "object") {
      // is price filter
      attributes = {
        "data-filter": "price",
        "data-active": "true",
        "aria-label": "Remove filter: Price range",
      };
      for (const priceGroup of filter) {
        if (priceGroup[0].indexOf("gte") !== -1) {
          attributes["data-filter-from"] = priceGroup[0];
          attributes["data-value-from"] = priceGroup[1];
        } else if (priceGroup[0].indexOf("lte") !== -1) {
          attributes["data-filter-to"] = priceGroup[0];
          attributes["data-value-to"] = priceGroup[1];
        }
      }
      label = `Price: ${Shopify.formatMoney(
        attributes["data-value-from"] * 100,
        theme.moneyFormatNoDecimals,
      )} - ${Shopify.formatMoney(attributes["data-value-to"] * 100, theme.moneyFormatNoDecimals)}`;
    } else {
      // is normal filter
      attributes = {
        "data-filter": filter[0],
        "data-value": filter[1],
        "data-active": "true",
        "aria-label": `Remove filter: ${decodeURIComponent(filter[1].replace(/\+/g, " "))}`,
      };
      label = decodeURIComponent(filter[1].replace(/\+/g, " "));
    }
    for (const key in attributes) {
      button.setAttribute(key, attributes[key]);
    }
    button.classList.add("active-filters__button");
    button.innerHTML = `${label}<span class="active-filters__cross" aria-hidden="true"></span>`;
    return button;
  }

  updateActiveFilters(filters = []) {
    const buttons = document.createDocumentFragment();
    let count = 0;
    let priceFilter = [];
    for (const filter of filters) {
      if (filter[0].indexOf("filter") !== -1) {
        if (filter[0].indexOf("filter.v.price") !== -1) {
          filter[1] !== "" ? priceFilter.push(filter) : null;
        } else {
          count++;
          const button = this.createActiveFilterButton(filter);
          buttons.appendChild(button);
        }
      }
    }
    if (priceFilter.length !== 0) {
      count++;
      const button = this.createActiveFilterButton(priceFilter);
      buttons.appendChild(button);
    }
    if (count > 0) {
      const clearButton = document.createElement("button");
      clearButton.classList.add("active-filters__clear");
      clearButton.setAttribute("data-clear", "true");
      clearButton.textContent = "Clear all";
      buttons.appendChild(clearButton);
    } else {
      this.querySelectorAll(`[type="checkbox"]`).forEach((filter) => {
        filter.checked = false;
      });
      this.querySelectorAll(`[type="number"]`).forEach((filter) => {
        filter.value = null;
      });
    }
    const activeFilters = this.querySelector(".active-filters");
    activeFilters.replaceChildren(buttons);
    this.querySelectorAll(".active-filters").forEach((container, index) => {
      if (index !== 0) {
        container.innerHTML = activeFilters.innerHTML;
      }
    });
  }

  resetDrawerState() {
    this.querySelectorAll(".filter__header").forEach((header) => {
      header.setAttribute("aria-expanded", "false");
    });
  }

  debounce(fn, wait = 300) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      fn.apply(this);
    }, wait);
  }
}
customElements.define("results-filters", ResultsFilters);

class ResultsSorting extends HTMLElement {
  constructor() {
    super();
  }

  addEventListeners() {
    this.addEventListener("input", this.changeHandler.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("input", this.changeHandler.bind(this));
  }

  changeHandler(e) {
    const event = new CustomEvent("results:refresh:start", {
      detail: {
        params: `sort_by=${e.target.value}`,
        type: "sort_by",
      },
    });
    document.dispatchEvent(event);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

customElements.define("results-sorting", ResultsSorting);

class MainCarousel extends HTMLElement {
  constructor() {
    super();

    this.defaultOptions = {
      loop: true,
    };

    this.elements = {
      swiper: this.querySelector(".main-carousel"),
      pagination: this.querySelector(".main-carousel__pagination"),
      prevButton: this.querySelector(".main-carousel__button-prev"),
      nextButton: this.querySelector(".main-carousel__button-next"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };
    if (this.elements.swiper.dataset.carouselOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.carouselOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      this.swiperOptions.navigation = {
        nextEl: this.elements.nextButton,
        prevEl: this.elements.prevButton,
      };
      this.elements.swiper.dataset.alignArrows
        ? (this.align_arrows = JSON.parse(this.elements.swiper.dataset.alignArrows))
        : null;
    }

    if (this.elements.pagination) {
      this.swiperOptions.pagination = {
        el: this.elements.pagination,
      };
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener("DOMContentLoaded", this.init.bind(this));
    window.addEventListener("resize", this.positionArrows.bind(this));
  }

  init() {
    if (!this.elements.swiper) return;
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);
    this.positionArrows();
  }

  positionArrows() {
    setTimeout(() => {
      if (!this.align_arrows || !this.elements.prevButton || !this.elements.nextButton) return;
      const slide_image_height = this.swiper.slidesEl.querySelector(".luc-media")?.offsetHeight;
      this.elements.nextButton.style.top = slide_image_height / 2 + "px";
      this.elements.nextButton.style.marginTop = -this.elements.nextButton.offsetHeight / 2 + "px";
      this.elements.prevButton.style.top = slide_image_height / 2 + "px";
      this.elements.prevButton.style.marginTop = -this.elements.prevButton.offsetHeight / 2 + "px";
    }, 1);
  }
}
customElements.define("main-carousel", MainCarousel);

class RecentlyViewedCarousel extends MainCarousel {
  constructor() {
    super();
    this.recentlyViewedHandles = JSON.parse(localStorage.getItem("recentlyViewedItems"));
    this.currentProduct = this.getAttribute("current-product");

    if (this.currentProduct && this.recentlyViewedHandles) {
      this.recentlyViewedHandles = this.recentlyViewedHandles.filter((handle) => {
        return handle != this.currentProduct;
      });
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener("DOMContentLoaded", this.fetchRecentlyViewed.bind(this));
  }

  async fetchRecentlyViewed() {
    if (!this.recentlyViewedHandles) return;

    try {
      const res = await fetch(
        `/search?view=recently-viewed-items&q=${this.recentlyViewedHandles.join(",")}`,
      );
      const data = await res.text();
      if (!data) return;
      this.renderRecentlyViewed(data);
    } catch (error) {
      console.log(error);
    }
  }

  renderRecentlyViewed(data) {
    const items = new DOMParser()
      .parseFromString(data, "text/html")
      .querySelector(".main-carousel__wrapper").innerHTML;
    const item_wrapper = this.querySelector(".main-carousel__wrapper");
    item_wrapper.innerHTML = items;
    this.init();
    this.closest(".recently-viewed-carousel").style.display = "block";
  }
}
customElements.define("recently-viewed-carousel", RecentlyViewedCarousel);

class RecommendationsCarousel extends HTMLElement {
  constructor() {
    super();

    this.defaultOptions = {
      loop: true,
    };

    this.elements = {
      swiper: this.querySelector(".main-carousel"),
      pagination: this.querySelector(".main-carousel__pagination"),
      prevButton: this.querySelector(".main-carousel__button-prev"),
      nextButton: this.querySelector(".main-carousel__button-next"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };
    if (this.elements.swiper.dataset.carouselOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.carouselOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      this.swiperOptions.navigation = {
        nextEl: this.elements.nextButton,
        prevEl: this.elements.prevButton,
      };
    }

    if (this.elements.pagination) {
      this.swiperOptions.pagination = {
        el: this.elements.pagination,
      };
    }

    this.limit = this.getAttribute("limit") || "8";
    this.intent = this.getAttribute("intent") || "related";
    this.product_id = this.getAttribute("product_id");
    this.section_id = this.getAttribute("section_id");
  }

  connectedCallback() {
    this.addEventListeners();
    this.init();
  }

  addEventListeners() {}

  async init() {
    if (!this.elements.swiper) return;
    const base_url = `${window.Shopify.routes.root}recommendations/products?section_id=${this.section_id}&product_id=${this.product_id}&limit=${this.limit}`;
    if (this.intent === "both") {
      const complementary = await this.getRecommendations(`${base_url}&intent=complementary`);
      if (complementary) {
        this.renderRecommendations(complementary);
      } else {
        const related = await this.getRecommendations(`${base_url}&intent=related`);
        if (related) {
          this.renderRecommendations(related);
        } else {
          this.style.display = "none";
        }
      }
    } else {
      const recommendations = await this.getRecommendations(`${base_url}&intent=${this.intent}`);
      if (recommendations) {
        this.renderRecommendations(recommendations);
      }
    }
  }

  async getRecommendations(url) {
    try {
      const response = await fetch(url);
      const data = await response.text();
      const html = new DOMParser()
        .parseFromString(data, "text/html")
        .querySelector(".main-product__complementary .main-carousel__wrapper");
      if (html.children.length > 0) {
        return html.innerHTML;
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
    }
  }

  renderRecommendations(data) {
    this.elements.swiper.querySelector(".main-carousel__wrapper").innerHTML = data;
    this.closest(".main-product__complementary").style.display = "block";
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);
  }
}
customElements.define("recommendations-carousel", RecommendationsCarousel);

class SearchRecentlyViewed extends HTMLElement {
  constructor() {
    super();
    this.recentlyViewedHandles = JSON.parse(localStorage.getItem("recentlyViewedItems"));
    this.currentProduct = this.getAttribute("current-product");

    if (this.currentProduct && this.recentlyViewedHandles) {
      this.recentlyViewedHandles = this.recentlyViewedHandles.filter((handle) => {
        return handle != this.currentProduct;
      });
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    if (!this.recentlyViewedHandles) return;
    document.addEventListener("DOMContentLoaded", this.fetchRecentlyViewed.bind(this));
  }

  async fetchRecentlyViewed() {
    if (!this.recentlyViewedHandles) return;

    try {
      const res = await fetch(
        `/search?view=search-recently-viewed-items&q=${this.recentlyViewedHandles.join(",")}`,
      );
      const data = await res.text();
      if (!data) return;
      this.renderRecentlyViewed(data);
    } catch (error) {
      console.log(error);
    }
  }

  renderRecentlyViewed(data) {
    const items = new DOMParser()
      .parseFromString(data, "text/html")
      .querySelector(".site-predictive-search__list").innerHTML;
    const item_wrapper = this.querySelector(".site-predictive-search__list");
    item_wrapper.innerHTML = items;
    this.classList.add("recently-viewed--loaded");
  }
}
customElements.define("search-recently-viewed", SearchRecentlyViewed);

class CartRecommendations extends HTMLElement {
  constructor() {
    super();

    this.defaultOptions = {
      loop: true,
    };

    this.elements = {
      swiper: this.querySelector(".main-carousel"),
      pagination: this.querySelector(".main-carousel__pagination"),
      prevButton: this.querySelector(".main-carousel__button-prev"),
      nextButton: this.querySelector(".main-carousel__button-next"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };
    if (this.elements.swiper.dataset.carouselOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.carouselOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      this.swiperOptions.navigation = {
        nextEl: this.elements.nextButton,
        prevEl: this.elements.prevButton,
      };
    }

    if (this.elements.pagination) {
      this.swiperOptions.pagination = {
        el: this.elements.pagination,
      };
    }

    this.limit = this.getAttribute("limit") || "10";
    this.intent = this.getAttribute("intent") || "related";
    this.section_id = this.getAttribute("section_id");
    this.allProductsString = this.dataset.products;
  }

  connectedCallback() {
    this.addEventListeners();
    this.init();
  }

  addEventListeners() {}

  async init() {
    if (!this.elements.swiper) return;
    this.allProductsIdArray = this.allProductsString.split(",");
    if (this.allProductsIdArray.length === 3) {
      this.limit = 4;
    } else if (this.allProductsIdArray.length === 2) {
      this.limit = 6;
    } else {
      this.limit = 10;
    }

    const urls = [];
    this.allProductsIdArray.forEach((productID) => {
      urls.push(
        `${window.Shopify.routes.root}recommendations/products?section_id=${this.section_id}&product_id=${productID}&limit=${this.limit}`,
      );
    });

    // left in option for different intent but current use will always default to related
    if (this.intent === "both") {
      const complementary = await this.getRecommendations(urls, this.intent);
      if (complementary) {
        this.renderRecommendations(complementary);
      } else {
        const related = await this.getRecommendations(urls, this.intent);
        if (related) {
          this.renderRecommendations(related);
        } else {
          this.style.display = "none";
        }
      }
    } else {
      const recommendations = await this.getRecommendations(urls, this.intent);
      if (recommendations) {
        this.renderRecommendations(recommendations);
      }
    }
  }

  async getRecommendations(urls, intent) {
    try {
      const responses = await Promise.all(
        urls.map((url) => {
          return fetch(`${url}&intent=${intent}`);
        }),
      );
      const domArray = await Promise.all(responses.map((response) => response.text()));

      const allProductSlides = domArray
        .map((html) => {
          const nodes = new DOMParser()
            .parseFromString(html, "text/html")
            .querySelectorAll("cart-recommendations .swiper-slide");
          return Array.from(nodes);
        })
        .flat();

      return allProductSlides;
    } catch (error) {
      console.log(error);
    }
  }

  renderRecommendations(data) {
    if (data.length <= 0) return;
    data.forEach((slide) => {
      this.elements.swiper.querySelector(".main-carousel__wrapper").appendChild(slide);
    });
    this.closest(".cart-related").style.display = "block";
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);
  }
}

customElements.define("cart-recommendations", CartRecommendations);

// Global event functions

function pushKlaviyo(data) {
  const item = {
    Name: data.title,
    ProductID: data.id,
    ImageURL: data.image,
    URL: `${window.location.origin}${data.url}`,
    Brand: data.vendor,
    Price: Shopify.formatMoney(data.price, theme.moneyFormat),
    CompareAtPrice: Shopify.formatMoney(
      data.original_price === data.price ? 0 : data.original_price,
      theme.moneyFormat,
    ),
  };
  _learnq.push(["track", "Added to Cart", item]);
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function trackRecentlyViewed(handle) {
  let recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewedItems"));
  if (!recentlyViewed) {
    recentlyViewed = [];
  }
  if (recentlyViewed.indexOf(handle) === -1) {
    recentlyViewed.unshift(handle);
  } else {
    const index = recentlyViewed.indexOf(handle);
    recentlyViewed.splice(index, 1);
    recentlyViewed.unshift(handle);
  }
  recentlyViewed = recentlyViewed.slice(0, 9);
  localStorage.setItem("recentlyViewedItems", JSON.stringify(recentlyViewed));
}
